(function () {
  "use strict";

  function addBodyClasses() {
    document.body.classList.add("page-loaded");
    document.body.classList.add("video-loaded");
    try {
      if (localStorage.getItem("minimized")) {
        document.body.classList.add("video-minimized");
      }
    } catch {
      /* ignore */
    }
  }

  function onContentsLoaded() {
    document.body.classList.add("contents-loaded");
  }

  function initScrollBodyClasses() {
    var lastY = window.scrollY || 0;
    function onScroll() {
      var y = window.scrollY || 0;
      document.body.classList.toggle("scrolled", y > 8);
      document.body.classList.toggle("scrolling-up", y < lastY);
      document.body.classList.toggle("scrollingUp", y < lastY);
      lastY = y;
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /**
   * When .blog-article-code-band (code rabbit) enters the viewport band, match live site:
   * body.dark-bg + main style background rgb(38,38,38) — see whiterabbit.group/what-does-white-rabbit-mean
   */
  function initDarkBgOnCodeBand() {
    var el = document.querySelector(".blog-article-code-band");
    if (!el) {
      return;
    }

    var main = document.getElementById("main");
    var DARK = "rgb(38, 38, 38)";

    function setDarkMode(on) {
      document.body.classList.toggle("dark-bg", on);
      if (main) {
        main.style.backgroundColor = on ? DARK : "";
      }
    }

    function updateFromRect() {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!vh) {
        return;
      }
      // Any overlap with the viewport (with small margins) = dark — reliable vs ratio thresholds on tall blocks
      var inView = rect.top < vh * 0.92 && rect.bottom > vh * 0.08;
      setDarkMode(inView);
    }

    updateFromRect();
    window.addEventListener("scroll", updateFromRect, { passive: true });
    window.addEventListener("resize", updateFromRect, { passive: true });

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function () {
          updateFromRect();
        },
        {
          threshold: [0, 0.01, 0.05, 0.1, 0.2, 0.35, 0.5, 0.65, 0.85, 1],
          rootMargin: "0px",
        },
      );
      io.observe(el);
    }
  }

  /**
   * Typewriter loop on .txt-rotate: type chars → hold (data-period ms) → delete → next word.
   * Optional: data-type-ms (default 55), data-delete-ms (default 40).
   */
  function initTxtRotate() {
    var nodes = document.querySelectorAll(".txt-rotate");
    nodes.forEach(function (el) {
      var raw = el.getAttribute("data-rotate");
      if (!raw) {
        return;
      }
      var words;
      try {
        words = JSON.parse(raw);
      } catch {
        return;
      }
      if (!words || !words.length) {
        return;
      }

      var holdMs = parseInt(el.getAttribute("data-period"), 10) || 2000;
      var typeMs = parseInt(el.getAttribute("data-type-ms"), 10) || 55;
      var deleteMs = parseInt(el.getAttribute("data-delete-ms"), 10) || 40;
      var wrap = el.querySelector(".wrap");

      function setText(s) {
        if (wrap) {
          wrap.textContent = s;
        } else {
          el.textContent = s;
        }
      }

      var wi = 0;
      var len = 0;
      var mode = "type";
      var timerId;

      function clearTimer() {
        if (timerId) {
          window.clearTimeout(timerId);
          timerId = null;
        }
      }

      function step() {
        clearTimer();
        var word = String(words[wi] || "");
        if (mode === "type") {
          if (len < word.length) {
            len += 1;
            setText(word.slice(0, len));
            el.classList.add("txt-rotate--typing");
            timerId = window.setTimeout(step, typeMs);
          } else {
            el.classList.remove("txt-rotate--typing");
            mode = "hold";
            timerId = window.setTimeout(function () {
              mode = "delete";
              step();
            }, holdMs);
          }
        } else if (mode === "delete") {
          if (len > 0) {
            len -= 1;
            setText(word.slice(0, len));
            el.classList.add("txt-rotate--typing");
            timerId = window.setTimeout(step, deleteMs);
          } else {
            el.classList.remove("txt-rotate--typing");
            wi = (wi + 1) % words.length;
            mode = "type";
            timerId = window.setTimeout(step, typeMs);
          }
        }
      }

      setText("");
      window.setTimeout(function () {
        step();
      }, 400);
    });
  }

  function initCodeBandAnimations() {
    var block = document.querySelector(".blog-article-code-band");
    if (!block) {
      return;
    }

    var line = block.querySelector(".blog-article-code-band__line");

    function reveal() {
      block.classList.add("blog-article-code-band--visible");
      if (line) {
        line.classList.add("blog-article-code-band__line--visible");
      }
    }

    if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
      gsap.set(block, { opacity: 0, y: 48, visibility: "visible" });
      if (line) {
        gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
      }
      gsap.to(block, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: block,
          start: "top 88%",
          once: true,
        },
        onComplete: function () {
          block.classList.add("loaded", "animated");
        },
      });
      if (line) {
        gsap.to(line, {
          scaleX: 1,
          duration: 0.85,
          delay: 0.35,
          ease: "power2.out",
          scrollTrigger: {
            trigger: block,
            start: "top 88%",
            once: true,
          },
          onComplete: function () {
            line.classList.add("loaded", "animated");
          },
        });
      }
    } else {
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                reveal();
                io.disconnect();
              }
            });
          },
          { threshold: 0.12 },
        );
        io.observe(block);
      } else {
        reveal();
      }
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    addBodyClasses();
    initScrollBodyClasses();
    initDarkBgOnCodeBand();
    initTxtRotate();
    initCodeBandAnimations();
  });

  window.addEventListener("load", function () {
    setTimeout(onContentsLoaded, 1000);
  });
})();
